
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { MEASURE_UNITS, PRODUCT_TYPES, TAXES_PERCENTAGES, TAXES_TYPES } from "@utils/Constants";
import { CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE, isCabysCoherentWithProductType } from "@utils/Cabys";
import { OpenCabysSearchPubSub } from "@utils/pubsubs/PubSub";
import { Button } from "reactstrap";

const CategoryFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "codigo",
                        "label": "Codigo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "codigo_cabys",
                        "label": "Codigo Cabys",
                        "isHorizontal": true,
                        "maxlength": 13,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        // Una categoria incoherente se propaga: el producto temporal copia su
                        // CAByS y su tipo. El test va en los dos campos porque Formik solo
                        // pinta el error en el que el usuario toco.
                        "validation": Yup.string()
                            .required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                            .test(
                                "cabys-tipo-producto",
                                CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE,
                                function (value) {
                                    return isCabysCoherentWithProductType(value, this.parent?.tipo_producto);
                                }
                            ),
                        "suffixButton": true,
                        "suffix": <Button
                            className="rounded-0"
                            block
                            color="primary"
                            type="button"
                            onClick={() => OpenCabysSearchPubSub.publish({ openOffCanvas: true })}>
                            Buscar
                        </Button>
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "nombre",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_producto",
                        "label": "Tipo predeterminado de Productos",
                        "options": PRODUCT_TYPES,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string()
                            .required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                            .test(
                                "cabys-tipo-producto",
                                CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE,
                                function (value) {
                                    return isCabysCoherentWithProductType(this.parent?.codigo_cabys, value);
                                }
                            ),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_impuesto",
                        "label": "Tipo predeterminado de Impuesto",
                        "options": TAXES_TYPES,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "porcentaje_impuesto",
                        "label": "Porcentaje predeterminado de Impuesto",
                        "options": TAXES_PERCENTAGES,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "unidad_medida",
                        "label": "Unidad de medida predeterminada",
                        "options": MEASURE_UNITS,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "exenta",
                        "label": "Exenta de Impuestos",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "activo",
                        "label": "Activa",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "sin_inventario",
                        "label": "Sin Inventario",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "force_description",
                        "label": "Cambiar descripcion obligatoriamente en productos temporales",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
            ]
        }
    ],
};


export default CategoryFormConfig;